var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xD0\xB8\xD0\xBA\xD0\xBE\xD0\xBD\xD0\xBA\xD0\xB0 \xD1\x82\xD0\xB5\xD0\xBB\xD0\xB5\xD1\x84\xD0\xBE\xD0\xBD_icon phone",
    d: "M2.59448 13.0536C2.61222 13.0853 2.63001 13.1143 2.64688 13.1459C2.66376 13.1767 2.67888 13.2083 2.69662 13.2399C5.83138 18.9357 11.3664 22.3567 12.4364 20.6437L13.7938 18.1926C13.9069 17.9834 13.8935 17.7249 13.7609 17.4832C13.7592 17.4806 13.7507 17.4726 13.7473 17.4673C13.5715 17.1083 13.405 17.0938 12.4592 16.4454C11.9695 16.0639 11.4481 15.6496 11.1047 15.3378C10.7715 15.0376 10.2873 15.011 10.0046 15.2735L9.45505 15.7944C9.26741 15.9718 9.01232 16.0678 8.75487 16.0577C7.979 16.03 6.53266 13.9145 5.72942 12.6121C5.50237 12.2425 5.32221 11.933 5.21837 11.7441C5.11541 11.5551 4.95024 11.238 4.75938 10.8483C4.08938 9.47368 3.07634 7.122 3.46975 6.45546C3.59972 6.23354 3.81938 6.0716 4.06946 6.00937L4.80566 5.82678C5.17953 5.73038 5.41719 5.30961 5.34259 4.86814C5.26391 4.41181 5.19432 3.75214 5.1344 3.13528C5.0949 1.99351 5.17107 1.84537 4.96269 1.50486C4.96105 1.49874 4.95865 1.48739 4.95695 1.48474C4.82355 1.24305 4.61153 1.0938 4.37346 1.07537L1.5682 0.895226C-0.461005 0.871547 -0.537733 7.36136 2.59448 13.0536Z",
    fill: "#0AA349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPhone);
export default __webpack_public_path__ + "static/media/greenPhone.29e0456409e3bfd83430132afe174cad.svg";
export { ForwardRef as ReactComponent };